var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.75 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#621e80;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#eab2ff;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.65,27.86l13.57,11.6c.66.56,1.45.86,2.29.86,1.4,0,2.66-.83,3.29-2.16.82-1.73.4-3.85-.99-5.04l-5.14-4.4h26.05c2.22,0,4.03-1.81,4.03-4.03s-1.81-4.03-4.03-4.03h-26.05l5.15-4.4c1.39-1.19,1.81-3.31.99-5.04-.63-1.33-1.89-2.16-3.29-2.16-.83,0-1.65.3-2.3.86l-13.57,11.6c-.89.76-1.4,1.92-1.4,3.17s.51,2.41,1.4,3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 49,
    height: 49,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.78,41v-2.28l3.37-.31,1.06-1.02V14.56h-4.44v-1.97l7.23-2.25h2.37v3.45c2.49-1.4,4.5-2.38,6.02-2.94,1.52-.56,2.86-.85,4.01-.85,2.71,0,4.79.82,6.23,2.47,1.44,1.64,2.16,4.03,2.16,7.15v17.78l1.06,1.02,3.34.31v2.28h-13.62v-2.28l2.98-.31,1.06-1.02v-16.7c0-2.36-.48-4.04-1.44-5.02-.96-.99-2.58-1.48-4.85-1.48-.99,0-2.07.17-3.22.51s-2.4.86-3.74,1.56v21.14l1.06,1.02,2.98.31v2.28h-13.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishArrow);
export default __webpack_public_path__ + "static/media/english-arrow.89bdded14ba5a59ccb9a0273ad3b6fd3.svg";
export { ForwardRef as ReactComponent };